import { SelectItem } from 'primeng/api';
import { WhatsappActionType } from '../enums';

export class WhatsappSetupActionTypeLookup {

    static getLookup(): SelectItem[] {
        return [
            { label: 'Abnormal Result', value: WhatsappActionType.ABNORMAL_RESULT },
            { label: 'Booking Appointment', value: WhatsappActionType.BOOKING_APPOINTMENT },
            { label: 'Cancel Admission', value: WhatsappActionType.CANCEL_ADMISSION },
            { label: 'Cancel Appointment', value: WhatsappActionType.CANCEL_APPOINTMENT },
            { label: 'Close ER Visits', value: WhatsappActionType.CLOSE_ER_VISITS },
            { label: 'Close Outpatient Visit', value: WhatsappActionType.CLOSE_OUTPATIENT_VISIT },
            { label: 'Discharge Admission', value: WhatsappActionType.DISCHARGE_ADMISSION },
            { label: 'New Admission', value: WhatsappActionType.NEW_ADMISSION },
            { label: 'Release Result', value: WhatsappActionType.RELEASE_RESULT },
            { label: 'Reminder Appointment', value: WhatsappActionType.REMINDER_APPOINTMENT },
            { label: 'Send Panic Released Result', value: WhatsappActionType.SEND_PANIC_RELEASED_RESULT },
            { label: 'Send Survey', value: WhatsappActionType.SEND_SURVEY },
        ];
    }
}
